export default __webpack_public_path__ + "static/10-wildcard-cd0b5823463918bce8e6c29029fd0980.png";